import { Home, Tags, ListChecks, ClipboardList } from "lucide-react";

/**
 * Single source of truth for the app's navigation entries — consumed by the
 * navbar sidebar (`components/AppSidebar.js`) and by the quick-nav cards on the
 * home page, so adding a screen only means adding a row here.
 *
 * Order is top-down in the sidebar, which mirrors right-to-left in the old
 * horizontal navbar (RTL).
 */
export const navItems = [
  {
    to: "/",
    label: "דף הבית",
    description: "מסך פתיחה",
    icon: Home,
    protected: false,
    quickNav: false,
  },
  {
    to: "/tags",
    label: "ניהול תגיות",
    description: "קטגוריות להזמנות",
    icon: Tags,
    protected: true,
    quickNav: true,
  },
  {
    to: "/statuses",
    label: "ניהול סטטוסים",
    description: "שלבי טיפול בהזמנה",
    icon: ListChecks,
    protected: true,
    quickNav: true,
  },
  {
    to: "/orders",
    label: "הזמנות",
    description: "צפייה, סינון ועריכה",
    icon: ClipboardList,
    protected: true,
    quickNav: true,
  },
];
